import { render, staticRenderFns } from "./typologyIdSelect.vue?vue&type=template&id=21a30bfd&"
import script from "./typologyIdSelect.vue?vue&type=script&lang=js&"
export * from "./typologyIdSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports